



































































































































import { Component, Vue } from 'vue-property-decorator'
import { FillInfoItemOfForm } from '../../../types/type'
import { getAllFatherNodeForTree, findItemForTree, disposeFillInfoToParamsForCM } from '../../../utils/toolsForCommon'
import countTo from 'vue-count-to'
import { CommonModule, UserModule } from '../../../store'
import { ElMessageComponent } from 'element-ui/types/message'
import DateUtil from '../../../utils/toolsForDate'
@Component({
  name: 'CapitalApplicationForUse',
  components: {
    'count-to': countTo,
    'my-dialog': () => import('../../../components/common/myDialog.vue'),
    'application-container-table': () => import('../../../components/applicationContainerTable/index.vue')
  }
})
export default class CapitalApplicationForUse extends Vue {
  public informationOverviewBase: Array<FillInfoItemOfForm> = [
    {
      title: '乡镇',
      type: 'text',
      key: 'villagesAndTowns',
      value: '',
      placeholder: '乡镇不可更改',
      content: '',
      disabled: true
    },
    {
      title: '学校',
      type: 'cascader',
      key: 'organizationName',
      value: '',
      placeholder: '请选择学校',
      treeData: [],
      content: '',
      disabled: true,
      isNecessary: true,
      temporaryStorageForValue: null
    },
    {
      title: '食堂专户名称',
      type: 'text',
      key: 'accountName',
      value: '',
      placeholder: '请输入食堂专户名称',
      content: '',
      isNecessary: true
    },
    {
      title: '食堂专户账号',
      type: 'text',
      key: 'account',
      value: '',
      placeholder: '请输入食堂专户账号',
      content: '',
      isNecessary: true
    },
    {
      title: '开户行',
      type: 'text',
      key: 'depositBank',
      value: '',
      placeholder: '请输入开户行',
      content: '',
      isNecessary: true
    },
    {
      title: '开户行号',
      type: 'text',
      key: 'depositBankCode',
      value: '',
      placeholder: '请输入开户行号',
      content: '',
      isNecessary: true
    },
    {
      title: '转入账户户名',
      type: 'text',
      key: 'receivingAccountName',
      value: '',
      placeholder: '请输入转入账户户名',
      content: '',
      isNecessary: false
    },
    {
      title: '转入账户账号',
      type: 'text',
      key: 'receivingAccount',
      value: '',
      placeholder: '请输入转入账户账号',
      content: '',
      isNecessary: false
    },
    {
      title: '转入账户开户行',
      type: 'text',
      key: 'receivingDepositBank',
      value: '',
      placeholder: '请输入转入账户开户行',
      content: '',
      isNecessary: false
    },
    {
      title: '转入开户行号',
      type: 'text',
      key: 'receivingDepositBankCode',
      value: '',
      placeholder: '请输入转入开户行号',
      content: '',
      isNecessary: false
    }
  ]
  public informationOverviewMoney: Array<FillInfoItemOfForm> = [
    {
      title: '划转城投账户资金总额',
      key: 'totalAmount',
      content: '',
      bgc: '#BFEDD6'
    },
    {
      title: '已申请使用资金总额',
      key: 'usedAmount',
      content: '',
      bgc: '#73E0E4'
    },
    {
      title: '已拨付资金',
      key: 'appliedAmount',
      content: '',
      bgc: '#C1BAFB'
    },
    {
      title: '待拨付资金',
      key: 'appropriatingAmount',
      content: '',
      bgc: '#F8B594'
    },
    {
      title: '余额',
      key: 'balance',
      content: '',
      bgc: '#A2E676'
    }
  ]
  public dialogFlagForUpdateBaseInfo: boolean = false
  public applicationContainerShow: boolean = false
  public loadingForInformationOverviewContent: boolean = false
  public detailInfo: any = {}
  public loadingForUpdateBaseInfo: boolean = false
  // charts：
  public myChart: any = null
  public option: any = {
    legend: {
      data: ['金额（元）'],
      left: '1%',
      top: '2%'
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    textStyle: {
      color: '#868686'
    },
    color: ['#568FE2'],
    grid: {
      left: '3%',
      right: '3%',
      bottom: '4%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: [],
      axisTick: {
        alignWithLabel: true
      }
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        name: '金额（元）',
        barWidth: '60%',
        data: [],
        type: 'bar'
      }
    ]
  }

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get userInfo () {
    return UserModule.userInfo
  }

  get orgName (): string {
    const org = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
    return org && org['name'] ? org['name'] : '- -'
  }

  get villagesAndTowns (): string {
    const fatherNodeForTree = getAllFatherNodeForTree(this.treeDataForOrganatizion, 'children', 'id', this.userInfo.organizationId)
    const villagesAndTownsId = fatherNodeForTree[fatherNodeForTree.length - 2]
    if (!villagesAndTownsId) return '- -'
    const villagesAndTownsRes = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', villagesAndTownsId)
    return villagesAndTownsRes && villagesAndTownsRes['name'] ? villagesAndTownsRes['name'] : '- -'
  }

  async mounted () {
    await Promise.all([
      CommonModule.getTreeDataForOrganization(),
      CommonModule.getTreeDataForSubOrganization()
    ])
    this.initCharts()
    this.updateCharts(this.option)
    this.disposeForFillInfoList()
    this.getDetailInfo()
  }

  // 选择框数据处理
  disposeForFillInfoList () {
    this.informationOverviewBase = this.informationOverviewBase.map(item => {
      switch (item.key) {
        case 'villagesAndTowns':
          item.value = this.villagesAndTowns
          break
        case 'organizationName':
          item.treeData = this.treeDataForSubOrganatizion
          item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
          item.temporaryStorageForValue = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
          break
      }
      return item
    })
  }

  async getDetailInfo (): Promise<ElMessageComponent | void> {
    try {
      const params = {
        orgId: this.userInfo.organizationId
      }
      this.loadingForInformationOverviewContent = true
      const { data: result } = await (this as any).$http.capitalInfo(params)
      this.loadingForInformationOverviewContent = false
      if (result.code !== 200) return this.$message.error(result.msg)
      const info = (result.data && result.data.length && result.data[0]) || {}
      this.detailInfo = info
      this.informationOverviewBase = this.informationOverviewBase.map(item => {
        const { key } = item
        switch (key) {
          case 'villagesAndTowns':
            item.value = this.villagesAndTowns
            item.content = this.villagesAndTowns
            break
          case 'organizationName':
            if (info['orgId']) {
              item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', info['orgId'])
              item.temporaryStorageForValue = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', info['orgId'])
            }
            item.content = item.temporaryStorageForValue.name
            if (this.villagesAndTowns === '- -') {
              item.content = '- -'
            }
            break
          default:
            item.value = info[key]
            item.content = info[key]
            break
        }
        item['editShow'] = false
        return item
      })
      this.informationOverviewMoney = this.informationOverviewMoney.map(item => {
        const { key } = item
        item.content = info[key]
        return item
      })
      let xAxisData = []
      let seriesData = []
      this.informationOverviewMoney.forEach(item => {
        xAxisData.push(item.title)
        const content = Number(item.content ? item.content : 0)
        seriesData.push(content)
      })
      this.option.xAxis.data = xAxisData
      this.option.series[0].data = seriesData
      this.updateCharts(this.option)
    } catch (err) {
      console.log(err)
    }
  }

  async saveForUpdateBaseInfo (): Promise<ElMessageComponent | void> {
    try {
      let whoEmpty = null
      const isEmpty = this.informationOverviewBase.some(item => {
        if (item.value === '' && item.isNecessary) {
          whoEmpty = item
          return true
        }
      })
      if (isEmpty) return this.$message.warning(whoEmpty.placeholder)
      const params = disposeFillInfoToParamsForCM(this.informationOverviewBase)
      const { id } = this.detailInfo
      if (id) Object.assign(params, { id })
      this.loadingForUpdateBaseInfo = true
      const { data: result } = await (this as any).$http.capitalInfoSave(params)
      this.loadingForUpdateBaseInfo = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(`基本信息更新成功`)
      this.dialogFlagForUpdateBaseInfo = false
      this.getDetailInfo()
    } catch (err) {
      console.log(err)
    }
  }

  operationForClickForUpdateBaseInfo (item) {
    this.informationOverviewBase = this.informationOverviewBase.map(v => {
      if (v.key === item.key) {
        v['editShow'] = true
      } else {
        v['editShow'] = false
      }
      v.value = v.content
      return v
    })
  }

  operationForClickForCancelUpdateBaseInfo () {
    this.informationOverviewBase = this.informationOverviewBase.map(v => {
      v['editShow'] = false
      v.value = v.content
      return v
    })
  }

  async submitForApplication (): Promise<ElMessageComponent | void> {
    try {
      const applyAmount = this.$refs.refForApplicationContainerTable['applyAmount']
      const applyReason = this.$refs.refForApplicationContainerTable['applyReason']
      if (!applyAmount) return this.$message.warning('请输入本次申请金额')
      if (!applyReason) return this.$message.warning('请输入资金申请事由')
      if (Number(applyAmount) > Number(this.detailInfo['balance'])) return this.$message.warning('申请资金不能大于余额，请修改')
      const params = this.informationOverviewBase.reduce((result, current) => {
        const { key, content } = current
        switch (key) {
          case 'villagesAndTowns':
            if (this.villagesAndTowns) {
              const villagesAndTownsRes = findItemForTree(this.treeDataForOrganatizion, 'children', 'name', this.villagesAndTowns)
              result['townName'] = villagesAndTownsRes['name']
              result['town'] = villagesAndTownsRes['id']
            }
            break
          case 'organizationName':
            const { name, id } = current.temporaryStorageForValue
            result['schoolName'] = name
            result['school'] = id
            break
          default:
            result[key] = content
            break
        }
        return result
      }, {})
      Object.assign(params, {
        applyAmount,
        applyReason,
        // time: DateUtil.getNowDayTime(),
        totalAmount: this.detailInfo.totalAmount,
        usedAmount: this.detailInfo.usedAmount,
        appliedAmount: this.detailInfo.appliedAmount,
        appropriatingAmount: this.detailInfo.appropriatingAmount,
        balance: this.detailInfo.balance
      })
      const { data: result } = await (this as any).$http.capitalAppInsert(params)
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success('资金使用申请审批表提交成功')
      setTimeout(() => {
        this.dialogFlagForUpdateBaseInfo = false
        this.$router.push({ name: 'CapitalApplicationForUseOfPending' })
      }, 500)
    } catch (err) {
      console.log(err)
    }
  }

  clickTitleOfContentMoney (item: FillInfoItemOfForm) {
    const { key } = item
    if (key !== 'totalAmount') return false
    this.$router.push({ name: 'CapitalShiftToHistoryOfSchool' })
  }

  initCharts () {
    const _that: any = this
    this.myChart = (this as any).$echarts.init(document.getElementById('echartsContainer'))
    window.addEventListener('resize', function () {
      _that.myChart.resize()
    })
  }

  updateCharts (option: any) {
    this.myChart.setOption(option, true)
  }
}
